import {DataModel} from "../form/DataModel.js";

export const mezok = [
  {
    id: 'Név',
    label: 'Név',
    input: {
      type: 'text',
      attrs: {
        autocomplete: 'name',
        required: true
      }
    },
    list: {
      width: 2
    }
  },
  {
    id: 'Gyártmány',
    label: 'Gyártó',
    input: {
      type: 'select',
      label: 'A gépkocsi gyártója',
      options: [ '- Gyártó' ],
      attrs: {
        autocomplete: 'on',
        required: true
      }
    },
    list: {
      width: 2
    }
  },
  {
    id: 'Modell',
    label: 'Modell',
    input: {
      type: 'select',
      label: 'A gépkocsi modell',
      options: [ '- Modell' ],
      attrs: {
        autocomplete: 'on',
        required: true
      }
    },
    list: {
      width: 2
    }
  },
  {
    id: 'Típus',
    label: 'Típus',
    input: {
      type: 'select',
      label: 'A gépkocsi típusa',
      options: [ '- Típus' ],
      attrs: {
        autocomplete: 'on',
        required: true
      }
    },
    list: {
      width: 2
    }
  },
  {
    id: 'Email',
    label: 'E-mail',
    input: {
      type: 'email',
      attrs: {
        autocomplete: 'email',
        required: true
      },

    }
  },
  {
    id: 'Telefonszám',
    label: 'Telefonszám',
    input: {
      type: 'tel',
      hint: '(Csak akkor hívjuk Önt, ha  az ajánlat készítése során kérdés merül fel, illetve a kiküldés után, hogy megkapta-e ajánlatunkat.)',
      attrs: {
        autocomplete: 'tel'
      }
    }
  },
  {
    id: 'GDPR',
    label: 'GDPR',
    input: {
      label: 'Hozzájárulok személyes adataim az <a href="http://forex.hu/adatkezeles" target="adatvedelmi_nyilatkozat">Adatvédelmi nyilatkozat</a> szerinti felhasználásához.',
      type: 'checkbox',
      attrs: {
        required: true
      }
    },
    list: false,
    view: false,
  },  
  {
    id: 'Adatvedelem',
    label: 'Adatvédelem',
    input: {
      label: 'Hozzájárulok, hogy a Forex kft. számomra ajánlatot küldjön. Erről a szolgáltatásról bármikor leiratkozhatok.',
      type: 'checkbox',
      attrs: {
        required: true
      }
    },
    list: false,
    view: false,
  },
  {
    id: 'Ajánlattétel',
    label: 'Kiküldve',
    component: 'ajanlat-statusz',
  },
  {
    id: 'Csoport',
    label: 'Webgalamb csoport',
    list: false,
    view: {
      hideEmpty: true
    }
  },
];

export const AjanlatKeres = new DataModel(mezok);